<template style="max-width:1700px">
  <div style="background-color:#0D0D2B">
    <!-- :style="`background-image: url(${require('../../assets/hero.svg')})`" -->
    <v-container
      class="mybackground hero d-flex justify-space-between"
      fluid
      fill-height
      style="width:80%"
    >
      <v-row class="my-15">
        <v-col style="max-width:650px">
          <h1
            :class="isMobile ? 'text-h3' : 'text-h2'"
            class="font-weight-bold"
            style="line-height:1.2"
          >Paying every-day bills with crypto has never been easier.</h1>
          <p
            style="max-width:500px"
            class="my-7"
            :class="paragraphText"
          >Owned by Australians, for Australians. We're the local partner you can trust for quick, secure and reliable transactions. </p>
          <v-btn
            color="primary"
            rounded
            x-large
            @click="$router.push('/signup')"
          >
            <span class="mr-2 text-body-1 font-weight-bold">Create Free Account</span>
            <v-icon>mdi-arrow-right-drop-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="my-15">
        <v-col>
          <v-card
            width="280"
            height="130"
            class="mx-2"
            style="display:inline-block; vertical-align:top; background-color:transparent; box-shadow:none"
          >
            <div class="d-flex">
              <img
                src="../../assets/icons/star.svg"
                alt="star icon"
              >
              <div class="ml-5 mt-3">
                <span
                  style="font-size:40px"
                  class="font-weight-bold"
                >4.8/5</span> <br />
                <span class="text-caption">Rating on Trustpilot</span>
              </div>
            </div>
          </v-card>
          <v-card
            width="280"
            height="130"
            class="mx-2"
            style="display:inline-block; vertical-align:top; background-color:transparent; box-shadow:none"
          >
            <div class="d-flex">
              <img
                src="../../assets/icons/person.svg"
                alt="person icon"
              >
              <div class="ml-5 mt-3">
                <span
                  style="font-size:40px"
                  class="font-weight-bold"
                >100k+</span> <br />
                <span class="text-caption">Happy customers</span>
              </div>
            </div>
          </v-card>
          <v-card
            width="280"
            height="130"
            class="mx-2"
            style="display:inline-block; vertical-align:top; background-color:transparent; box-shadow:none"
          >
            <div class="d-flex">
              <img
                src="../../assets/icons/star.svg"
                alt="graph icon"
              >
              <div class="ml-5 mt-3">
                <span
                  style="font-size:40px"
                  class="font-weight-bold"
                >10k+</span> <br />
                <span class="text-caption">Monthly transactions</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      class="d-flex align-center"
      style="width:80%"
    >
      <v-img
        src="../../assets/background-shape-rectangle.svg"
        style="position: absolute; left: 0"
      />
      <div>
        <v-row :style="isMobile? '':'d-flex space-between'">
          <v-col v-if="$vuetify.breakpoint.lg">
            <v-img
              src="../../assets/brochureimage.svg"
              max-width="500px"
            ></v-img>
          </v-col>
          <v-col>
            <div>
              <span
                :class="subHeaderText"
                style="line-height:1.2"
              >Why choose </span>
              <span
                :class="subHeaderText"
                style="line-height:1.2"
              >EasyCrypto</span>
              <p
                class="py-5"
                :class="paragraphText"
              >If you're a complete beginner to crypto, you'll feel right at home with us. We make buying and spending your crypto as effortless as paying your rent or water bills.</p>
              <v-btn
                color="primary"
                rounded
                large
                @click="$router.push('/signup')"
              >Get started, it's free
                <v-icon class="ml-2">mdi-arrow-right-drop-circle</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-container
      fluid
      fill-height
      style="background-image:linear-gradient(#0D0D2B 0%, #0D0D2B 60%, #F8F9FB 60%, #F8F9FB 100%)"
      class="py-15"
    >
      <v-row class="d-flex align-center justify-center my-15">
        <v-col
          align="center"
          :cols=" isMobile? 12: 8"
        >
          <span :class="subHeaderText">We make paying bills easy</span>
          <p
            :class="paragraphText"
            class="my-7"
            style="max-width:500px"
          >See how easy it is to pay your bills with EasyCrypto below.</p>
          <v-stepper
            v-model="e1"
            light
            max-width="600"
            style="border-radius:15px; box-shadow: 0 0 40px rgb(57 23 119 / 0.2)"
          >
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                step="1"
              >
                Choose coin
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e1 > 2"
                step="2"
              >
                Enter amount
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                Enter bill details
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <!-- //put hereeeeeeeeeeeeeeeeeeeeee -->
                <v-card
                  height="150px"
                  style="box-shadow:none"
                >
                  <v-card-title
                    class="text-h5 font-weight-medium"
                    style="word-break:unset; color:#2B076Es"
                  >1. Choose coin</v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="selectedCoin"
                      outlined
                      placeholder="Select one"
                      :items="coins"
                      hide-details
                    >
                      <template v-slot:selection="{ item }">
                        <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
                      </template>
                      <template v-slot:item="{ item }">
                        <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
                      </template>
                    </v-select>
                  </v-card-text>
                </v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    x-large
                    rounded
                    color="primary"
                    @click="e1 = 2"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <!-- //put hereeeeeeeeeeeeeeeeeeeeee -->
                <v-card
                  height="200px"
                  style="box-shadow:none"
                  class="px-5"
                >
                  <div
                    class="text-h5 font-weight-medium text-left"
                    style="word-break:unset; color:#2B076Es"
                  >2. Enter amount</div>
                  <v-text-field
                    v-model="audAmount"
                    @input="calculateCoinAmount(audAmount)"
                    label="You send"
                    suffix="AUD"
                    placeholder="0.00"
                    type="number"
                    hide-details
                    class="mt-4"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="coinAmount"
                    @input="calculateAudAmount(coinAmount)"
                    label="You pay"
                    suffix="BTC"
                    placeholder="0.00"
                    type="number"
                    hide-details
                    class="mt-2"
                    outlined
                  ></v-text-field>
                </v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    x-large
                    rounded
                    text
                    color="primary"
                    @click="e1 = 1"
                  >
                    Back
                  </v-btn>
                  <v-btn
                    x-large
                    rounded
                    color="primary"
                    @click="e1 = 3"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="3">
                <!-- //put hereeeeeeeeeeeeeeeeeeeeee -->
                <v-card
                  height="230px"
                  style="box-shadow:none"
                  class="px-5"
                >
                  <div
                    class="text-h5 font-weight-medium text-left"
                    style="word-break:unset; color:#2B076Es"
                  >3. Enter bill details</div>
                  <v-btn-toggle
                    mandatory
                    style="width:100%"
                    class="mt-2"
                    light
                  >
                    <v-btn
                      @click="addressType = 'bank'"
                      style="width:50%"
                      checked
                    >
                      <v-icon
                        class="mr-1"
                        small
                        color="#2B076Es"
                      >mdi-bank</v-icon>
                      Bank
                    </v-btn>
                    <v-btn
                      @click="addressType = 'bpay'"
                      style="width:50%"
                    >
                      <v-icon
                        class="mr-1"
                        small
                        color="#2B076Es"
                      >mdi-receipt</v-icon>
                      Bpay
                    </v-btn>
                  </v-btn-toggle>
                  <div v-if="addressType === 'bank'">
                    <v-text-field
                      v-model="address.bank.bsb"
                      label="BSB"
                      placeholder="Enter BSB"
                      hide-details
                      outlined
                      class="mt-2"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="address.bank.accountNumber"
                      label="Account Number"
                      placeholder="Enter account number"
                      hide-details
                      outlined
                      class="mt-2"
                    >
                    </v-text-field>
                  </div>
                  <div v-if="addressType === 'bpay'">
                    <v-text-field
                      v-model="address.bpay.biller"
                      label="Biller code"
                      placeholder="Enter biller code"
                      hide-details
                      outlined
                      class="mt-2"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="address.bpay.ref"
                      label="Reference"
                      placeholder="Enter customer reference"
                      hide-details
                      outlined
                      class="mt-2"
                    >
                    </v-text-field>
                  </div>
                </v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    x-large
                    rounded
                    text
                    color="primary"
                    @click="e1 = 2"
                  >
                    Back
                  </v-btn>
                  <v-btn
                    x-large
                    rounded
                    color="primary"
                    @click="$router.push('/signup')"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
      <v-img
        src="../../assets/backgroundshapes.svg"
        style="position: absolute; right: 0;"
      />
    </v-container>
    <v-container
      fluid
      class="d-flex justify-center pb-15"
      fill-height
      style="background-color:#F8F9FB; color:#0D0D2B"
    >
      <div style="width:80%">
        <v-row class="pb-15">
          <v-col>
            <span :class="subHeaderText">What people are saying...</span>
            <v-row
              class="my-4"
              :class="!$vuetify.breakpoint.lg ? 'd-flex flex-col paragraphText' : 'paragraphText' "
            >
              <v-col :class="isMobile ? '':'d-flex flex-row'">
                <div class="pa-4 text-h6 font-weight-light">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit doloribus nulla quos assumenda? Hic quisquam dolorum ducimus dolorem eum eaque molestias fugit animi quibusdam quidem error consequatur, minima veritatis quo!
                </div>
                <div class="pa-4 text-h6 font-weight-light">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit doloribus nulla quos assumenda? Hic quisquam dolorum ducimus dolorem eum eaque molestias fugit animi quibusdam quidem error consequatur, minima veritatis quo!
                </div>
                <div class="pa-4 text-h6 font-weight-light">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit doloribus nulla quos assumenda? Hic quisquam dolorum ducimus dolorem eum eaque molestias fugit animi quibusdam quidem error consequatur, minima veritatis quo!
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container
      fluid
      class="d-flex align-center justify-center py-15"
      style="background-color:#2B076E"
    >
      <v-img
        src="../../assets/background-shape-rectangle.svg"
        style="position: absolute; left: 0"
      />
      <div
        style="width:80%"
        class="py-15"
      >
        <v-row class="mb-0">
          <v-col>
            <span :class="subHeaderText">Get started in 3 simple steps</span>
          </v-col>
        </v-row>
        <div>
          <v-card
            class="rounded-xl px-5 py-2 mr-8 my-4 "
            width="300"
            height="215"
            color="#491F98"
            style="display:inline-block; vertical-align:top"
            onmouseover="this.style.background='#5224A9';"
            onmouseout="this.style.background='#491F98';"
          >
            <v-card-title class="text-h6 font-weight-bold">
              1. <br /> Create an account
            </v-card-title>
            <v-card-text>
              Create an account and verify your email.
            </v-card-text>
          </v-card>
          <v-card
            color="#491F98"
            class="rounded-xl px-5 py-2 mr-8 my-4"
            width="300"
            height="215"
            style="display:inline-block; vertical-align:top"
            onmouseover="this.style.background='#5224A9';"
            onmouseout="this.style.background='#491F98';"
          >
            <v-card-title class="text-h6 font-weight-bold">
              2. <br /> Verify your ID
            </v-card-title>
            <v-card-text>
              Verify your identity without any hassle.
            </v-card-text>
          </v-card>
          <v-card
            color="#491F98"
            class="rounded-xl px-5 py-2 mr-8 my-4"
            width="300"
            height="215"
            style="display:inline-block; vertical-align:top"
            onmouseover="this.style.background='#5224A9';"
            onmouseout="this.style.background='#491F98';"
          >
            <v-card-title class="text-h6 font-weight-bold">
              3. <br /> Pay your bills
            </v-card-title>
            <v-card-text>
              Pay your bills with our world's leading cryptocurrencies.
            </v-card-text>
          </v-card>
        </div>
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              x-large
              rounded
              class="my-2"
              @click="$router.push('/signup')"
            >Get started today
              <v-icon class="ml-2">mdi-arrow-right-drop-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-img
        src="../../assets/backgroundshapes.svg"
        style="position: absolute; right: 0;"
      />
    </v-container>
    <!-- style="background-image:linear-gradient(#2B076E, #0D0D2B)" -->
    <v-container
      fluid
      class="d-flex justify-center my-10"
      style="background-color:#0D0D2B"
    >
      <!-- <div
        class="py-5 px-10"
        :class="isMobile? '':'d-flex justify-space-between'"
        style="background-color:#3671E9; border-radius:16px; width:80%"
      >
        <div class="mb-5 mr-10">
          <span class="text-h5 font-weight-bold">Pay your bills with crypto</span> <br />
          <div
            style="max-width:400px"
            class="mt-5"
          >
            Join our mailing list to get the latest news and start paying your bills with crypto.
          </div>
        </div>
        <div :class="isMobile? '':'d-flex align-center'">
          <v-text-field
            label="Enter your email"
            class="mr-5"
            block
          ></v-text-field>
          <v-btn
            light
            color="white"
            large
            rounded
          >Subscribe</v-btn>
        </div>
      </div> -->
      <div
        style="width:80%"
        class="text-caption"
        :class="isMobile? '':'d-flex'"
      >
        <v-row>
          <v-col>
            <img
              src="../../assets/logo.svg"
              alt="logo"
            >
            <br /> <br />
            ACN: 123123123 <br />
            ABN: 12312312312
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row :class="isMobile? '':'d-flex'">
          <v-col class="ma-2">
            <span
              class="font-weight-bold"
              style="font-size:18px"
            >Start Here</span> <br />
            Sign up <br />
            Buy &amp; Sell <br />
            Our Rates <br />
            Portfolio Tracker
          </v-col>
          <v-col class="ma-2">
            <span
              class="font-weight-bold"
              style="font-size:18px"
            >Useful links</span> <br />
            Knowledge Base <br />
            Learn About Crypto <br />
            Blog <br />
            Careers
          </v-col>
          <v-col class="ma-2">
            <span
              class="font-weight-bold"
              style="font-size:18px"
            >About Us</span> <br />
            About Us <br />
            Get Help <br />
            Terms of Service <br />
            Privacy Policy
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container
      fluid
      style="background-color:#0D0D2B; width:80%"
      class="text-caption py-10"
    >
      <v-row>
        <v-col>
          &#169; {{ new Date().getFullYear() }} EasyCrypto. Built by <a href="https://lauracao.dev/">Laura Cao</a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      subHeaderText: 'text-h3 font-weight-bold',
      paragraphText: 'text-body-1 font-weight-light',
      coins: [{ id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' }],
      selectedCoin: { id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' },
      btcPriceSell: null,
      btcPriceBuy: null,
      audAmount: null,
      coinAmount: null,
      transactionCost: 20,
      demoSellOrderStep: 1,
      addressType: 'bank',
      address: {
        bank: {
          nickname: null,
          bsb: null,
          accountNumber: null,
          accountName: null,
        },
        bpay: {
          nickname: null,
          biller: null,
          ref: null,
        }
      },
      e1: 1,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    calculateAudAmount(val) {
      this.audAmount = (val * this.btcPriceSell + this.transactionCost).toFixed(2)
    },
    calculateCoinAmount(val) {
      this.coinAmount = ((val - this.transactionCost) / this.btcPriceSell).toFixed(8)
    },
    async getLivePrices() {
      try {
        const response = await fetch('https://api.btcmarkets.net/v3/markets/BTC-AUD/ticker')
        const btcTicker = await response.json()
        this.btcPriceBuy = Number(btcTicker.bestBid)
        this.btcPriceSell = Number(btcTicker.bestAsk)
        console.log('buy price updated to:', this.btcPriceBuy)
        console.log('sell price updated to:', this.btcPriceSell)
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {
    this.getLivePrices()
  }
}
</script>

<style scoped>
.hero {
  background-image: url("../../assets/hero.svg");
}
</style>
